module.exports = __webpack_public_path__ + "img/sansheng.0c780b3e.jpg";